import React, { ChangeEvent, FC, useEffect, useState } from 'react'
import { Icon } from '@iconify/react'
import S from './Faq.styles'

interface SearchProps {
  placeholder?: string
  onChange: (value: string) => void
  onClear?: () => void
}

const Search: FC<SearchProps> = ({ placeholder = '', onChange, onClear }) => {
  const [value, setValue] = useState('')
  const [showClear, setShowClear] = useState(false)

  const handleChange = (ev: ChangeEvent<HTMLInputElement>) => {
    setValue(ev.currentTarget.value)
    onChange(ev.currentTarget.value)
  }

  const handleClear = () => {
    setValue('')
    onChange('')
    onClear?.()
  }

  useEffect(() => {
    if (value.length > 0) {
      setShowClear(true)
    } else {
      setShowClear(false)
    }
  }, [value])

  return (
    <S.Searchbox>
      <input type="text" value={value} placeholder={placeholder} onChange={handleChange} />
      {showClear && (
        <button type="button" onClick={handleClear}>
          &times;
        </button>
      )}
      <Icon icon="tabler:search" />
    </S.Searchbox>
  )
}

export default Search
